import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import UserManagementApiService from 'client/utils/clientApiHelper'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_SAVE_DEFAULT_LOCATION } from 'Store/Identity/DefaultLocation/DefaultLocationType';
import { setISSaveDefaultLocation } from 'Store/Identity/DefaultLocation/DefaultLocationAction';

function* getSaveDefaultLocationSaga(req: any): any {
    try {
        yield put(globalLoaderText("Saving Default Location...."));
        let payloadData : IPayload= {
            apiType : apiType.Identity,
            endpoint : `userprofile/defaultLocation`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
           
        }
        const response = yield call(
            UserManagementApiService.callUserPost,API_URL.PostWebApp,payloadData
        );
        
            yield put(setISSaveDefaultLocation(response));
            yield put(globalLoaderText(""));
        

    } catch (error) {
        yield put(setISSaveDefaultLocation(null))
        yield put(globalLoaderText(""));
    }
}

function* watchRegion() {
    yield takeEvery(GET_SAVE_DEFAULT_LOCATION, getSaveDefaultLocationSaga);
}

export default function* combinedSaga() {
    yield all([
        watchRegion()
    ])
}
